<template>
    <div id="main-wrapper" :dir="$i18n.locale == 'ar'? 'rtl':'ltr'">
        <NavbarDark/>

        <div class="page-title" :class="{ 'ltr': $i18n.locale === 'en', 'rtl': $i18n.locale === 'ar' }">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12 col-md-12">
                        <h2 class="ipt-title">{{$t('Delete Account')}}</h2>
                    </div>
                </div>
            </div>
        </div>

        <!-- Delete Account Steps -->
        <section class="py-5 bg-light">
        <div class="container">
            <div class="row align-items-center g-4">
              <div class="col-12">
                  <div class="delete-steps">
                    <h4 class="mb-3">{{ $t('Steps to Delete Your Account') }}</h4>
                    <ul class="steps-list">
                        <li>{{ $t('1. login to your account') }}</li>
                        <li>{{ $t('2. Go to your profile sidebar.') }}</li>
                        <li>{{ $t('3. Click on “Delete Account” option.') }}</li>
                        <li>{{ $t('4. Confirm your decision in the popup window.') }}</li>
                        <li>{{ $t('5. Once confirmed, your account will be deactivated immediately.') }}</li>
                    </ul>
                  </div>
              </div>
            </div>
            <br>
            <div class="row text-center mb-5 g-4">
              <div class="col-lg-4 col-md-4 col-12" v-for="i in 3" :key="i">
                <img
                  :src="$i18n.locale === 'ar' ? require(`@/assets/img/ar/img${i}.jpg`) : require(`@/assets/img/en/img${i}.jpg`)"
                  class="img-fluid rounded shadow-sm"
                  :alt="`Delete Illustration ${i}`"
                />
              </div>
            </div>
        </div>
        </section>

    <FooterTop :bg="'theme-bg'" />
    <FooterDark />
    <ScrollToTop />
  </div>
</template>

<script setup>
import NavbarDark from '@/components/navbar/navbar-dark.vue'
import FooterTop from '@/components/footer/footer-top.vue'
import FooterDark from '@/components/footer/footer-dark.vue'
import ScrollToTop from '@/components/scroll-to-top.vue'
import { computed } from 'vue';
import { useHead } from '@vueuse/head'
import { useRoute } from 'vue-router'
const route = useRoute()
const baseUrl = 'https://ruqm.me'

const canonicalUrl = computed(() =>
  `${baseUrl}${route.path}`
)

const supportedLocales = ['en', 'ar']

const hreflangLinks = computed(() => {
  const pathWithoutLang = route.path.replace(/^\/(en|ar)/, '')

  return supportedLocales.map(lang => ({
    rel: 'alternate',
    hreflang: lang,
    href: `${baseUrl}/${lang}${pathWithoutLang}`
  }))
})
useHead(() => ({
  link: [
    { rel: 'canonical', href: canonicalUrl.value },
    ...hreflangLinks.value,
    {
      rel: 'alternate',
      hreflang: 'x-default',
      href: `${baseUrl}/en${route.path.replace(/^\/(en|ar)/, '')}`
    }
  ]
}))
</script>

<style scoped>
.delete-steps {
  padding: 2rem;
  border-radius: 12px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.05);
}

.steps-list {
  list-style: none;
  padding-left: 0;
  line-height: 1.8;
}
.steps-list li {
  position: relative;
  padding-left: 1.8rem;
  margin-bottom: 0.5rem;
  font-size: 1rem;
}
.steps-list li::before {
  content: "✔";
  color: #C48B6E;
  position: absolute;
  left: 0;
  font-weight: bold;
}
.alert-warning {
  background-color: #fff3cd;
  color: #856404;
  border: none;
  border-radius: 8px;
}
</style>
